import bemFactory from 'react-bem-factory';

export const qa = bemFactory.qa('wfl-standalone-card');
export const createTemplateButtonDataQa = qa('create-template-button');
